import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "./landingPage/Header";
import SiteCtaAndFooter from "./landingPage/SiteCtaAndFooter";
import free50Thumb from "./landingPage/images/free50.png";
import "./seo/seo-pages.css";

const FREE_RESOURCES = [
  {
    slug: "free50",
    to: "/free50",
    title: "Top Free 50 Words",
    description:
      "Completely free digital book (ebook), available instantly. Learn the most frequent words in the Quran with high-frequency Quranic Arabic vocabulary to help you understand the Quran, read with confidence, and support Quran memorization (hifz).",
    thumbnail: free50Thumb,
    thumbnailAlt:
      "Free digital book: top 50 most common Quranic Arabic words — ebook for learning Quranic Arabic and understanding the Quran",
  },
];

export default function FreeResources() {
  return (
    <>
      <Helmet>
        <title>Free Quranic Arabic Resources – Vocabulary and Quran Learning Guides | Qurania</title>
        <meta
          name="description"
          content="Free resources for learning Quranic Arabic: high-frequency Quran words, vocabulary for understanding the Quran, and guides that complement Quran memorization. Download from Qurania."
        />
        <link rel="canonical" href="https://www.quranstories.pro/free" />
        <meta property="og:title" content="Free Quranic Arabic Resources – Qurania" />
        <meta
          property="og:description"
          content="Free guides for Quranic vocabulary, the most common words in the Quran, and building skills for understanding and memorizing the Quran."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.quranstories.pro/free" />
      </Helmet>
      <Header />
      <main className="seo-page-main blog-list-page free-resources-page">
        <div className="container">
          <div className="blog-list-hero">
            <h1 className="blog-list-title">Free Resources</h1>
            <p className="blog-list-subtitle">
              Free downloads for learning Quranic Arabic, mastering frequent Quran words, and getting clearer understanding of the Quran—tools that also help learners who are working on Quran memorization.
            </p>
          </div>
          <ul className="free-resources-grid">
            {FREE_RESOURCES.map((item) => (
              <li key={item.slug} className="free-resources-card-wrap">
                <Link to={item.to} className="free-resources-card">
                  <div className="free-resources-thumb-wrap">
                    <img
                      src={item.thumbnail}
                      alt={item.thumbnailAlt}
                      className="free-resources-thumb"
                      width={520}
                      height={693}
                      loading="lazy"
                    />
                  </div>
                  <div className="free-resources-card-body">
                    <span className="free-resources-card-badge">Free Book</span>
                    <h2 className="free-resources-card-title">{item.title}</h2>
                    <p className="free-resources-card-desc">{item.description}</p>
                    <span className="free-resources-card-cta">Get this free ebook →</span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          <nav className="free-resources-internal" aria-label="Related blog guides">
            <h2 className="blog-related-title">Related reading on the blog</h2>
            <ul className="blog-related-list">
              <li>
                <Link to="/blog/most-common-words-quran">Most common words in the Quran</Link>
              </li>
              <li>
                <Link to="/blog/10-common-quranic-words">10 common Quranic words you see every day</Link>
              </li>
              <li>
                <Link to="/blog/beginner-guide-quranic-arabic">Beginner guide to Quranic Arabic</Link>
              </li>
              <li>
                <Link to="/blog/word-by-word-quran-understand">Word-by-word Quran understanding</Link>
              </li>
              <li>
                <Link to="/learn-quranic-arabic">Learn Quranic Arabic with the Qurania app</Link>
              </li>
            </ul>
          </nav>
        </div>
      </main>
      <SiteCtaAndFooter downloadTrackingPage="free" />
    </>
  );
}
